//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  angular.module('curalate').service('TrackingParamsService', [
    '$http',
    '$q',
    'PermissionsService',
    'PromiseService',
    function ($http, $q, PermissionsService, PromiseService) {
      const utmSourceLabel = 'Source (utm_source)';
      const utmMediumLabel = 'Vendor/Medium (utm_medium)';
      const utmCampaignLabel = 'Campaign Name (utm_campaign)';
      const utmContentLabel = 'Campaign Content (utm_content)';
      const utmTermLabel = 'Terms Being Tested (utm_term)';

      const BASE_URL = '/api/settings/tracking-params';
      const RECENT_PARAMS_URL = '/api/params/recent-default';

      this.hasConfigurePermission = PermissionsService.hasPermissionForTask(
        'tracking_parameters:configure',
      );
      this.hasOverridePermission = PermissionsService.hasPermissionForTask(
        'tracking_parameters:override',
      );

      this.previewUrlHost = 'http://baseurl.com/';

      const GOOGLE_ID = 'google';

      const GOOGLE_NAMES = [
        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_content',
        'utm_term',
      ];

      const labels = {
        google: {
          name: 'Google Analytics',
          label: 'Default Google Analytics Parameters',
          paramLabels: {
            utm_source: utmSourceLabel,
            utm_medium: utmMediumLabel,
            utm_campaign: utmCampaignLabel,
            utm_content: utmContentLabel,
            utm_term: utmTermLabel,
          },
        },
        custom: {
          name: 'Custom Parameters',
          label: 'Add Custom Parameters',
        },
      };

      this.getParamDropdownOptions = function () {
        return [
          {
            name: 'Bazaarvoice Touchpoint',
            value: 'distribution_touchpoint',
          },
        ];
      };

      this.getReservedParamDropdownOptions = function () {
        return [
          { name: 'None', value: 'none' },
          { name: utmMediumLabel, value: 'utm_medium' },
          { name: utmCampaignLabel, value: 'utm_campaign' },
          { name: utmContentLabel, value: 'utm_content' },
          { name: utmTermLabel, value: 'utm_term' },
        ];
      };

      this.getLabelForGoogleValue = function (value) {
        return labels.google.paramLabels[value] || 'Unknown label';
      };

      this.getReservedParameterValue = function () {
        return 'curalate_reserved';
      };

      this.fetchTrackingSettings = function () {
        return PromiseService.processHttpResponse($http.get(BASE_URL));
      };

      this.searchTrackingParams = function (
        searchTerm,
        name,
        searchNames,
        limit,
      ) {
        const params = {
          searchString: searchTerm,
          paramName: name,
          findNames: searchNames,
          limit,
        };
        return PromiseService.processHttpResponse(
          $http.get(RECENT_PARAMS_URL, { params }),
        );
      };

      this.getTrackingSettings = function () {
        return this.fetchTrackingSettings().then((response) => {
          _(response.trackingParams.paramGroups).each((paramGroup) => {
            const groupLabels = labels[paramGroup.id] || {
              name: '',
              label: '',
              paramLabels: {},
            };
            paramGroup.name = groupLabels.name;
            paramGroup.label = groupLabels.label;

            _.each(paramGroup.params, (param) => {
              param.label =
                (groupLabels.paramLabels &&
                  groupLabels.paramLabels[param.name]) ||
                param.name;
            });
          });

          return response;
        });
      };

      this.saveTrackingParams = function (params) {
        return PromiseService.processHttpResponse($http.put(BASE_URL, params));
      };

      this.findInUseTrackingParams = function (params) {
        const inUseParams = angular.copy(params);
        inUseParams.paramGroups = _.filter(
          inUseParams.paramGroups,
          (paramGroup) => paramGroup.inUse,
        );

        return inUseParams;
      };

      this.getParamGroupIndex = function (params, id, doNotRequireGroup) {
        const indexValue = params.paramGroups
          ? params.paramGroups.findIndex((pg) => pg.id === id)
          : -1;
        if (!doNotRequireGroup && indexValue < 0) {
          throw new Error('group $id not found');
        }
        return indexValue;
      };

      this.sortGoogleParams = function (param1, param2) {
        return (
          GOOGLE_NAMES.indexOf(param1.name) - GOOGLE_NAMES.indexOf(param2.name)
        );
      };

      this.isGoogleParam = function (param) {
        return GOOGLE_NAMES.indexOf(param.name) >= 0;
      };

      this.sortParams = function (params) {
        const googleParamIndex = this.getParamGroupIndex(
          params,
          GOOGLE_ID,
          /* doNotRequireGroup */ true,
        );
        if (googleParamIndex >= 0) {
          const sortedGoogleGroup = params.paramGroups[
            googleParamIndex
          ].params.sort(this.sortGoogleParams);
          params.paramGroups[googleParamIndex].params = sortedGoogleGroup;
        }
        return params;
      };
    },
  ]);
})();
